module.exports = __webpack_public_path__ + "static/media/icon-sync-blue.dd9ef314.svg";